import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';

import { SidebarIconComponent } from './sidebar-icon.component';
import { SidebarThemePickerComponent } from './sidebar-theme-picker.component';
import { SidebarMenuGroupView, SidebarMenuItemView } from '../sidebar.models';

@Component({
  selector: 'app-sidebar-navigation',
  standalone: true,
  imports: [RippleModule, TooltipModule, SidebarIconComponent, SidebarThemePickerComponent],
  templateUrl: './sidebar-navigation.component.html',
  styleUrls: ['./sidebar-navigation.component.scss'],
})
export class SidebarNavigationComponent {
  @Input({ required: true }) collapsed = false;
  @Input({ required: true }) groups: SidebarMenuGroupView[] = [];

  @Output() itemSelected = new EventEmitter<SidebarMenuItemView>();

  selectItem(item: SidebarMenuItemView): void {
    if (item.disabled) {
      return;
    }

    this.itemSelected.emit(item);
  }

  isCurrentPage(item: SidebarMenuItemView): boolean {
    const hasActiveSubItem = item.subItems?.some((subItem) => subItem.isActive) ?? false;
    return item.isActive && !hasActiveSubItem;
  }

  isSystemGroup(groupId: string): boolean {
    return groupId === 'system';
  }
}
